import { useState } from "react";
import { Button } from "@/components/ax/Button";
import { EpistemicBadge } from "@/components/ax/EpistemicRow";
import { Sheet } from "@/components/ax/Sheet";
import { useI18n } from "@/i18n";

export const RefChip = ({ item }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={t("refchip.aria", { id: item.ref ?? item.id })}
        data-testid={`ref-chip-${item.ref ?? item.id}`}
        className="inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-[8px] border border-[rgba(13,148,136,0.3)] px-2 font-mono text-[13px] leading-[18px] text-ax-link transition-colors duration-150 hover:bg-[rgba(13,148,136,0.1)]"
      >
        {item.ref ?? item.id}
      </button>
      {open && (
        <Sheet open onOpenChange={setOpen} title={t("item.itemTitle", { id: item.ref ?? item.id })} testId="ref-sheet">
          <EpistemicBadge value={item.epistemic} />
          <p className="m-0 mt-3 text-base leading-6 text-ax-text" data-testid="ref-sheet-text">
            {item.text}
          </p>
          <p className="m-0 mt-3 font-mono text-[13px] leading-[18px] text-ax-muted">
            {t("item.source")}: {item.source}
          </p>
          <Button onClick={() => setOpen(false)} data-testid="ref-sheet-close" className="mt-6 w-full">
            {t("items.close")}
          </Button>
        </Sheet>
      )}
    </>
  );
};
